module.exports = __webpack_public_path__ + "img/lungs-virus.56301034.svg";